var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x36_4px_boxes"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Production"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1200c2",
    d: "M32,44.3689c-1.144,0-2.075,0.931-2.075,2.0752S30.856,48.519,32,48.519 c1.1443,0,2.0752-0.9308,2.0752-2.075S33.1443,44.3689,32,44.3689z M32,8.4996c-12.9579,0-23.5,10.5422-23.5,23.5002 C8.5,44.958,19.0421,55.5003,32,55.5003c12.958,0,23.5-10.5423,23.5-23.5004C55.5,19.0418,44.958,8.4996,32,8.4996z M32,50.8317 c-10.3835,0-18.8314-8.4479-18.8314-18.8318c0-10.3838,8.4478-18.8317,18.8314-18.8317c10.3838,0,18.8314,8.4479,18.8314,18.8317 C50.8314,42.3838,42.3838,50.8317,32,50.8317z M32,19.6309c1.1443,0,2.0752-0.9308,2.0752-2.075s-0.9309-2.075-2.0752-2.075 c-1.144,0-2.075,0.9308-2.075,2.075S30.856,19.6309,32,19.6309z M17.5561,29.925c-1.1442,0-2.0751,0.9308-2.0751,2.075 c0,1.144,0.9309,2.075,2.0751,2.075c1.1441,0,2.075-0.9309,2.075-2.075C19.6311,30.8559,18.7002,29.925,17.5561,29.925z  M46.4442,29.925c-1.1442,0-2.0752,0.9308-2.0752,2.075c0,1.144,0.931,2.075,2.0752,2.075c1.144,0,2.075-0.9309,2.075-2.075 C48.5192,30.8559,47.5883,29.925,46.4442,29.925z M40.3318,26.3423l-7.6731,2.9455l-8.1865-9.2079 c-0.4883-0.5503-1.322-0.6617-1.9418-0.2321c-0.6693,0.4639-0.8357,1.3824-0.3719,2.0518l8.0085,11.5546l0.0322,0.0466 c0.005,0.0073,0.0109,0.0137,0.0162,0.0209l-5.242,10.5626c-0.2388,0.4811-0.0423,1.0648,0.439,1.3035 c0.1389,0.069,0.2863,0.1017,0.4315,0.1017c0.3578,0,0.7023-0.1984,0.8721-0.5406l5.2352-10.5494 c0.3571-0.0037,0.7178-0.096,1.0475-0.2905l8.6256-5.0897c0.6166-0.3632,0.8995-1.1288,0.6343-1.819 C41.9635,26.4312,41.1009,26.0471,40.3318,26.3423z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e386ce7b341904283ac52a70f8b81602.svg";
export { ForwardRef as ReactComponent };